import React, { useContext } from "react";
import { ThreadContext } from "../../../context/threadContext";
import {Tooltip} from "react-tooltip";

const ThreadPromoteNoti = () => {
	const { thread, toggleTempOff, threadData } = useContext(ThreadContext);

	if (!thread) {
		return null;
	}

	return (
		<div className="p-4 text-white bg-primary bg-opacity-85 rounded-lg">
			{!thread.ft_tempOff && (
				<p className="mb-4">
					Loại bài viết:
					<b>
						{thread.ft_premium ? ' Tin VIP' : ' Tin thường'}
						{(thread.ft_slide || thread.ft_waitingSlide) && ' + Slide'}
						{(thread.ft_slidePre || thread.ft_waitingSlidePre) && ' + SlidePremium'}
						{thread.ft_related && ' + Related'}
					</b>
				</p>
			)}

			{thread.ft_waitingSlide === 1 && (
				<p className="mb-4">
					Trạng thái Slide: <b>Đang chờ duyệt</b>
				</p>
			)}

			{thread.ft_waitingSlidePre === 1 && (
				<p className="mb-4">
					Trạng thái Slide Premium: <b>Đang chờ duyệt</b>
				</p>
			)}

			{!thread.is_expired ? (
				<p className="mb-4">
					Bài viết sẽ hết hạn vào: <b className="text-red-500">{thread.expire_date}</b>
				</p>
			) : (
				<p className="mb-4">
					Bài viết đã hết hạn.
				</p>
			)}

			<div className="flex items-center gap-x-2">
				{thread.can_renew && (
					<a href={`${thread.view_url}renew`} className="button button--cta">Gia hạn</a>
				)}

				{thread.can_temp_off && (
					<div>
						<Tooltip id="toggle-temp-off-tooltip" className="z-50"/>

						<button
							onClick={toggleTempOff}
							className="button button--cta"
							data-tooltip-id="toggle-temp-off-tooltip"
							data-tooltip-content={'Click để thay đổi trạng thái'}
						>
							Tình trạng: {threadData.temp_off ? 'Cáo bận' : 'Làm việc'}
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default ThreadPromoteNoti;